import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Header, Paragraph, Section, Form } from '../components/Typography';
import TextInput from '../components/TextInput';
import Button from '../components/Button';

const isDevelop = process.env.NODE_ENV === 'development';

const EmailForm = ({ api, onSubmit, recaptchaConfig, recaptchaVerified }) => {
  const [email, setEmail] = useState('');

  const { getToken, reset, siteKey, verifiCallbackString } = recaptchaConfig;

  const handleChangeEmail = e => {
    const value = e.target.value || '';
    setEmail(value);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const token = getToken();
    const success = await api.registerEmail(email, token);

    if (success) onSubmit();
    else reset();
  };

  const disableSubmit = !email || (!recaptchaVerified && !isDevelop);

  return (
    <>
      <Section>
        <Header>Interested in becoming an AI trainer?</Header>
        <Paragraph>
          <strong>We’d be happy to have you on board!</strong>
        </Paragraph>
        <Paragraph>
          Our online training consists of interactive elements, videos, quizzes
          and practical assignments - you get to work hands-on with the boost.ai
          platform to get a feel for what it’s like to build your own virtual
          agent.
        </Paragraph>
        <Paragraph>
          It is the expressway for you to start utilizing the boost.ai platform.
        </Paragraph>
        <Paragraph>
          Plus, you'll get a certificate upon completion that you can proudly
          display to show off your newly acquired skills on your social media
          channels.
        </Paragraph>
      </Section>
      <Section>
        <Paragraph>
          <strong>I want to take the onboarding!</strong>
        </Paragraph>
        <Paragraph>
          Of course you do! But access to our platform is restricted due to
          security and capacity measures. As a result, you don't get immediate
          access. To gain access you will first need to confirm your email, and
          then choose when you want to begin your onboarding.
        </Paragraph>
      </Section>
      <Form onSubmit={handleSubmit}>
        <label htmlFor="certiself-email">Email</label>
        <TextInput
          type="email"
          name="certiself-email"
          id="certiself-email"
          onChange={handleChangeEmail}
          value={email}
          required
        />
        {!isDevelop && (
          <Recaptcha
            className="g-recaptcha"
            data-sitekey={siteKey}
            data-callback={verifiCallbackString}
          />
        )}
        <Button type="submit" disabled={disableSubmit}>
          SUBMIT
        </Button>
      </Form>
    </>
  );
};

const Recaptcha = styled.div`
  #certiself-form & {
    margin-bottom: 24px;
  }
`;

export default EmailForm;
